var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('w-g-list',{attrs:{"pagination":false,"fieldInit":_vm.field,"keyField":'id',"sortingFunctionGenerator":_vm.sortingFunctionGenerator,"headerItems":_vm.headerItems,"itemsToDisplay":_vm.tableItems},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var element = ref.element;
return [_c('project-bar',{attrs:{"projectData":element,"view":'full'}})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }